import { useEffect, useState } from "react";
import { useSwiperSlide } from "swiper/react";

// Прозрачный пиксель: пока настоящая картинка не нужна, в <img> лежит он,
// поэтому на странице не мелькает подпись (alt) и ничего не скачивается.
const BLANK =
    "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

/**
 * Картинка внутри слайда Swiper.
 *
 * В каруселях с плавной сменой (fade) все слайды лежат друг на друге, поэтому
 * браузер считает их видимыми и скачивает все картинки сразу, даже с
 * loading="lazy". Здесь картинка загружается, только когда её слайд
 * активен или следующий (для плавной смены без пустого кадра). Уже
 * загруженная картинка больше не выгружается.
 *
 * priority: загрузить сразу (первый слайд).
 */
const SlideImage = ({ src, srcSet, sizes, priority = false, ...rest }) => {
    const slide = useSwiperSlide();
    // Вне Swiper (slide отсутствует) ведём себя как обычная картинка
    const needed = !slide || slide.isActive || slide.isNext;
    const [wanted, setWanted] = useState(priority || !slide);

    useEffect(() => {
        if (needed) setWanted(true);
    }, [needed]);

    return (
        <img
            src={wanted ? src : BLANK}
            srcSet={wanted ? srcSet : undefined}
            sizes={wanted ? sizes : undefined}
            fetchpriority={priority ? "high" : undefined}
            decoding="async"
            {...rest}
        />
    );
};

export default SlideImage;
